<template>
  <div>
    <van-sticky>
      <cooperation-search-head
        :titleInfo="titleInfo"
        @handSearch="handSearch"
        :shadow="true"
        :showBg="false"
        :companyList="companyList"
      >
        <!-- <div @click="handselectDate" class="icon-date-text">
          <img src="../../../common/images/visa-change/date.png" alt />
          <span>{{ moment(new Date()).format('DD') }}</span>
        </div> -->
      </cooperation-search-head>
    </van-sticky>
    <div class="pannel-wrap" v-if="pannel">
      <transition
        name="default"
        v-on:enter="menuEnter"
        v-on:leave="menuLeave"
        enter-class="default-enter"
        leave-to-class="default-leave-to"
      >
        <div class="select-date" v-if="pannel">
          <div class="content">
            <div class="title">注册时间截止:</div>
            <div class="date-wrap">
              <span @click="selectDate(0)">{{
                stDate ? stDate : '请选择时间'
              }}</span
              >至
              <span @click="selectDate(1)">{{
                edDate ? edDate : '请选择时间'
              }}</span>
            </div>
          </div>
          <div class="footbar">
            <div class="footbar-wrap">
              <span @click="cancel">重置</span>
              <span @click="submit">确认</span>
            </div>
          </div>
        </div>
      </transition>
      <div
        class="pannel-mask"
        v-if="pannel"
        @click="
          () => {
            this.pannel = false;
          }
        "
      ></div>
    </div>
    <nav-title title="招募信息列表"></nav-title>
    <div class="recruit-list">
      <van-list
        :offset="30"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="(item, index) in list" :key="index">
          <template>
            <div class="recruit-item" @click="handInfo(item.recruitGuid)">
              <div class="sub-title">
                <span style="line-height:1.5">{{
                  item.xRecruitmentplanname
                }}</span>
                <div>
                  <!-- <Icon :name="item.status==="1"?"报名中":"已截止"" :status="item.status"></Icon> -->
                  <Icon
                    :status="item.status"
                    :name="item.status == 1 ? '报名中' : '已截止'"
                  ></Icon>
                </div>
              </div>
              <div class="rest-detail">
                <!-- <div>
                    <span>发布时间：</span>
                    <span>{{
                      item.releaseDate &&
                        moment(item.releaseDate).format('YYYY-MM-DD')
                    }}</span>
                  </div> -->
                <div>
                  <span>注册时间：</span>
                  <span>
                    {{
                      item.releaseDate &&
                        moment(item.releaseDate).format('YYYY-MM-DD')
                    }}至
                    {{
                      item.registerEndDate &&
                        moment(item.registerEndDate).format('YYYY-MM-DD')
                    }}
                  </span>
                </div>
                <div>
                  <span>开放注册公司：</span>
                  <span>{{ item.openRegRegions }}</span>
                </div>
              </div>
            </div>
          </template>
        </van-cell>
      </van-list>
    </div>
    <van-popup v-model="popupShowStart" position="bottom">
      <van-datetime-picker
        v-model="startDate"
        @cancel="onCancel(0)"
        @confirm="e => onConfirm(0, e)"
        :formatter="formatter"
        type="date"
      />
    </van-popup>
    <van-popup v-model="popupShowEnd" position="bottom">
      <van-datetime-picker
        v-model="endDate"
        @cancel="onCancel(1)"
        @confirm="e => onConfirm(1, e)"
        :formatter="formatter"
        type="date"
      />
    </van-popup>
  </div>
</template>

<script>
import navTitle from './recruit-title';
import Icon from './sing-up-status';
import cooperationSearchHead from '../../cooperation-packge/components/cooperation-search-head-cp';
import { List, PullRefresh, Sticky, Popup, DatetimePicker } from 'vant';
import moment from 'moment';
import { getUrlParams } from 'common/js/mUtils';

export default {
  components: {
    navTitle,
    Icon,
    cooperationSearchHead,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  },
  data() {
    return {
      index: 1,
      list: [],
      current: 1,
      size: 10,
      loading: false,
      finished: false,
      refreshing: false,
      moment,
      showDropSelect: false,
      companyList: [],
      date: moment(new Date()).format('DD'),
      titleInfo: {
        selectname: '注册截止日期',
        selectTitle: '注册截止日期',
        subtitle: '开放注册公司'
      },
      popupShowStart: false,
      popupShowEnd: false,
      startDate: new Date(),
      endDate: new Date(),
      stDate: '',
      edDate: '',
      params: {
        current: 1,
        size: 10
      },
      pannel: false
    };
  },
  created() {
    this._getRecruitList();
    this._getComplay({ type: 'recruit' });
  },
  methods: {
    _getComplay({ type }) {
      let { providerGuid } = getUrlParams();
      this.$api
        .getCompanyList({
          providerGuid,
          type
        })
        .then(res => {
          let { status, body } = res;
          if (status) {
            this.companyList = body.map(item => {
              return {
                text: item,
                value: item
              };
            });
          }
        });
    },
    _getRecruitList(params = {}) {
      let { current, size } = this;
      params = { ...params, current, size };
      this.$api.getRecruitList(params).then(res => {
        let { code, body } = res;
        if (code == '0000') {
          let { records } = body;
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    handInfo(recruitGuid) {
      this.$router.push({
        name: 'recruitmentNoticeDetail',
        query: {
          recruitGuid
        }
      });
    },
    onLoad() {
      let { params } = this;
      this.current++;

      this._getRecruitList(params);
    },
    onRefresh() {
      this.finished = false;
      this.list = [];
      this.current = 1;
      this._getRecruitList();
    },
    menuEnter: function(el, done) {
      el.offsetWidth;
      el.style.maxHeight = '290px';
      el.style.transition = 'all 0.3s ease-in';
      done();
    },
    menuLeave: function(el) {
      el.offsetWidth;
      el.style.maxHeight = 0;
      el.style.transition = 'all 0.3s ease-out';
    },
    handSearch(data) {
      this.list = [];
      let params = { ...data, current: 1, openRegRegions: data.buguid };
      this.params = params;
      this.current = 1;
      this._getRecruitList(params);
      this.loading = false;
      this.finished = false;
    },
    handselectDate() {
      this.pannel = !this.pannel;
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    selectDate(type) {
      type ? (this.popupShowEnd = true) : (this.popupShowStart = true);
    },
    onCancel(type) {
      type ? (this.popupShowEnd = false) : (this.popupShowStart = false);
    },
    onConfirm(type, e) {
      type ? (this.popupShowEnd = false) : (this.popupShowStart = false);
      if (type) {
        this.edDate = moment(e).format('YYYY-MM-DD');
      } else {
        this.stDate = moment(e).format('YYYY-MM-DD');
      }
    },
    submit() {
      this.list = [];
      this.pannel = !this.pannel;
      let { params, startDate, endDate, stDate, edDate } = this;
      startDate = moment(startDate).format('YYYY-MM-DD');
      endDate = moment(endDate).format('YYYY-MM-DD');
      params = Object.assign({}, params, {
        startDate: stDate ? startDate : '',
        endDate: edDate ? endDate : ''
      });
      this._getRecruitList(params);
    },
    cancel() {
      let { params } = this;
      params = Object.assign({}, params, { startDate: '', endDate: '' });
      this.stDate = '';
      this.edDate = '';
      this._getRecruitList(params);
      this.pannel = !this.pannel;
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-date-text {
  position: relative;
  top: 8px;
  left: 8px;
  img {
    width: 44px;
    height: 44px;
    display: inline-block;
  }
  span {
    position: absolute;
    left: 8px;
    top: 8px;
    font-size: 22px;
    color: #4d5250;
  }
}

.default-enter-active {
  transition: all 0.3s ease-in;
}

.default-leave-active {
  transition: all 0.3s ease-out;
}

.default-enter,
.default-leave-to {
  max-height: 0;
}
.pannel-wrap {
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 100%;
  .select-date {
    background: #fff;
    position: relative;
    .content {
      height: 196px;
      padding: 40px 0px 0px 30px;
      .title {
        color: #333333;
        font-size: 28px;
      }
      .date-wrap {
        display: flex;
        align-items: center;
        margin-top: 20px;
        span {
          width: 320px;
          height: 68px;
          border: 1px solid rgba(185, 185, 185, 1);
          border-radius: 8px;
          display: inline-block;
          color: #999;
          font-size: 28px;
          text-align: center;
          line-height: 68px;
        }
        span:nth-child(1) {
          margin-right: 10px;
        }
        span:nth-child(2) {
          margin-left: 10px;
        }
      }
    }
    .footbar {
      height: 88px;
      position: relative;
      .footbar-wrap {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        color: #656565;
        font-size: 32px;
        span {
          flex: 1;
          text-align: center;
          display: inline-block;
          height: 100%;
          line-height: 88px;
          position: relative;
        }
        span:nth-child(1)::after {
          position: absolute;
          content: '';
          border-right: 1px solid #d5d9df;
          transform: scaleX(0.5);
          right: 0px;
          top: 0px;
          height: 100%;
          display: inline-block;
        }
        span:nth-child(2) {
          color: #41c795;
        }
      }
    }
    .footbar::before {
      position: absolute;
      content: '';
      border-top: #d5d9df 1px solid;
      display: block;
      transform: scaleY(0.5);
      width: 100%;
    }
  }
  .pannel-mask {
    position: absolute;
    background: #000;
    opacity: 0.4;
    height: 100%;
    z-index: 1001;
    width: 100%;
  }
  // .fade-enter-active,
  // .fade-leave-active {
  //   transition: all 0.3s ease;
  // }
  // .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  //   height: 0;
  //   opacity: 0;
  // }
}

.recruit-list {
  padding: 0px 32px;
  padding-right: 0px;
  background: #fff;
  /deep/ .van-cell {
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 0px;
    overflow: hidden;
    color: #323233;
    font-size: 0.28rem;
    line-height: 1;
    background-color: #fff;
  }
  .recruit-item {
    border-bottom: 1px solid #efefef;
    padding: 30px 0px;
    .sub-title {
      display: flex;
      justify-content: space-between;
      span:nth-child(1) {
        color: #000;
        font-size: 32px;
        font-weight: 500;
      }
    }
    .rest-detail {
      margin-top: 20px;
      color: #666666;
      font-size: 26px;
      > div {
        line-height: 1.8;
      }
      div:nth-child(2) {
        display: flex;
        span:nth-child(1) {
          // width: 210px;
        }
        span:nth-child(2) {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .tendering {
      display: flex;
      flex-wrap: wrap;
      > div {
        width: 45%;
      }
    }
  }
}
/deep/ .van-picker__cancel,
.van-picker__confirm {
  height: 100%;
  padding: 0 0.32rem;
  font-size: 0.28rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #42c796;
}
/deep/ .van-picker__confirm {
  color: #42c796;
}
/deep/ .van-picker-column__item--selected {
  color: #42c796;
}
</style>
